import { render, staticRenderFns } from "./Depositlist.vue?vue&type=template&id=7015ef22&scoped=true"
import script from "./Depositlist.vue?vue&type=script&lang=js"
export * from "./Depositlist.vue?vue&type=script&lang=js"
import style0 from "./Depositlist.vue?vue&type=style&index=0&id=7015ef22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015ef22",
  null
  
)

export default component.exports